
import { computed, defineComponent, onMounted, ref } from 'vue'
import { Html5Outlined, BlockOutlined, CloudUploadOutlined } from '@ant-design/icons-vue'
import { useStore } from 'vuex'
import { GlobalDataProps } from '../store/index'
import useLoadMore from '../hooks/useLoadMore'
import TemplateList from '../components/TemplateList.vue'
export default defineComponent({
  components: {
    TemplateList,
    Html5Outlined,
    BlockOutlined,
    CloudUploadOutlined
  },
  setup() {
    const store = useStore<GlobalDataProps>()
    const searchText = ref('')
    const testData = computed(() => store.state.templates.data)
    const total = computed(() => store.state.templates.totalTemplates)
    const isLoading = computed(() => store.getters.isOpLoading('fetchTemplates') ?? false)

    const onSearch = () => {
      store.dispatch('fetchTemplates', { searchParams: { pageIndex: 0, pageSize: 8, title: searchText.value } })
    }
    const { loadMorePage, isLastPage } = useLoadMore('fetchTemplates', total, { pageIndex: 0, pageSize: 8 })
    onMounted(() => {
      onSearch()
      // 使用 loadMorePage 非常容易就实现了一个下拉加载
      // window.addEventListener('scroll', (e) => {
      //   // get body height
      //   const totalPageHeight = document.body.scrollHeight
      //   // get scrollPoint
      //   const scrollPoint = window.scrollY + window.innerHeight
      //   if (scrollPoint >= totalPageHeight && !isLastPage.value) {
      //     console.log('at the bottom')
      //     loadMorePage()
      //   }
      // })
    })
    return {
      searchText,
      onSearch,
      testData,
      isLoading,
      loadMorePage,
      isLastPage
    }
  }
})
